import * as statuses from 'constants/statuses';
import * as subscriptionStatuses from './constants/subscriptionStatuses';
import * as forecastStatuses from './constants/forecastStatuses';
import * as logReasonStatuses from './constants/logReasonStatuses';

import {
  CANCEL_SUBSCRIPTION_FAIL,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_FAIL,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_TICKET,
  EMPTY_SUBSCRIPTION_TICKET,
  FETCH_FORECAST_CANCEL,
  FETCH_FORECAST_FAILURE,
  FETCH_FORECAST_REQUEST,
  FETCH_FORECAST_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE,
  FETCH_SUBSCRIPTIONS_REQUEST,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTION_LOG_REASONS_FAILURE,
  FETCH_SUBSCRIPTION_LOG_REASONS_REQUEST,
  FETCH_SUBSCRIPTION_LOG_REASONS_SUCCESS,
  SNOOZE_SUBSCRIPTION_AUTHENTICATION_FAILURE,
  SNOOZE_SUBSCRIPTION_FAILURE,
  SNOOZE_SUBSCRIPTION_REQUEST,
  SNOOZE_SUBSCRIPTION_SUCCESS,
  START_SUPPLEMENTS_CONSULTATION_FROM_UPSELL,
  UPDATE_SUBSCRIPTION_SUCCESS,
} from './actionTypes';

const initialState = {
  status: subscriptionStatuses.IDLE,
  snoozeError: null,
  subscriptions: [],
  subscriptionLogReasons: [],
  subscriptionLogReasonStatus: logReasonStatuses.IDLE,
  subscriptionForecast: [],
  subscriptionForecastStatus: forecastStatuses.NOT_AVAILABLE,
  subscriptionTicket: null,
  supplementsConsultationFromUpsellStarted: false,
  cancelSubscriptionStatus: statuses.IDLE,
};

export default function subscriptionsReducer(state = initialState, action) {
  switch (action.type) {
    case CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        cancelSubscriptionStatus: statuses.LOADING,
      };
    case CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: state.subscriptions.map(subscription => {
          if (subscription.pubkey === action.subscription.pubkey) {
            return action.subscription;
          }
          return subscription;
        }),
        cancelSubscriptionStatus: statuses.SUCCESS,
      };
    case CANCEL_SUBSCRIPTION_FAIL:
      return {
        ...state,
        cancelSubscriptionStatus: statuses.ERROR,
      };

    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: [action.subscription, ...state.subscriptions],
        status: subscriptionStatuses.SUCCESS,
      };
    case CREATE_SUBSCRIPTION_FAIL:
      return {
        ...state,
        status: subscriptionStatuses.ERROR,
      };
    case CREATE_SUBSCRIPTION_TICKET:
      return {
        ...state,
        subscriptionTicket: action.ticket,
      };

    case EMPTY_SUBSCRIPTION_TICKET:
      return {
        ...state,
        subscriptionTicket: null,
      };

    case FETCH_FORECAST_CANCEL:
      return {
        ...state,
        subscriptionForecastStatus: forecastStatuses.NOT_AVAILABLE,
      };
    case FETCH_FORECAST_FAILURE:
      return {
        ...state,
        subscriptionForecastStatus: forecastStatuses.NOT_AVAILABLE,
      };
    case FETCH_FORECAST_REQUEST:
      return {
        ...state,
        subscriptionForecast: [],
        subscriptionForecastStatus: forecastStatuses.NOT_AVAILABLE,
      };
    case FETCH_FORECAST_SUCCESS:
      return {
        ...state,
        subscriptionForecast: action.payload,
        subscriptionForecastStatus: forecastStatuses.AVAILABLE,
      };

    case FETCH_SUBSCRIPTION_LOG_REASONS_FAILURE:
      return {
        ...state,
        subscriptionLogReasonStatus: logReasonStatuses.ERROR,
      };
    case FETCH_SUBSCRIPTION_LOG_REASONS_REQUEST:
      return {
        ...state,
        subscriptionLogReasonStatus: logReasonStatuses.LOADING,
      };
    case FETCH_SUBSCRIPTION_LOG_REASONS_SUCCESS:
      return {
        ...state,
        subscriptionLogReasons: action.subscriptionLogReasons,
        subscriptionLogReasonStatus: logReasonStatuses.SUCCESS,
      };

    case FETCH_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        status: subscriptionStatuses.ERROR,
      };
    case FETCH_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        status: subscriptionStatuses.LOADING,
      };
    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptions: action.subscriptions,
        status: subscriptionStatuses.SUCCESS,
      };

    case SNOOZE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        // Snooze failure don't invalidate subscription data
        status: subscriptionStatuses.SUCCESS,
        // Message to show in the UI
        snoozeError: action.error,
      };
    case SNOOZE_SUBSCRIPTION_AUTHENTICATION_FAILURE:
      return {
        ...state,
        status: subscriptionStatuses.ERROR,
      };
    case SNOOZE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        snoozeError: null,
        status: subscriptionStatuses.SNOOZING,
      };
    case SNOOZE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: state.subscriptions.map(subscription => {
          if (subscription.pubkey === action.subscription.pubkey) {
            return action.subscription;
          }
          return subscription;
        }),
        status: subscriptionStatuses.SUCCESS,
      };

    case START_SUPPLEMENTS_CONSULTATION_FROM_UPSELL:
      return {
        ...state,
        supplementsConsultationFromUpsellStarted: true,
      };

    case UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptions: state.subscriptions.map(subscription => {
          if (subscription.pubkey === action.subscription.pubkey) {
            return action.subscription;
          }
          return subscription;
        }),
        status: subscriptionStatuses.SUCCESS,
      };

    default:
      return state;
  }
}
